import { FC, useState, useEffect } from "react";
import { MantineProvider } from "@mantine/core";
import { theme } from "./theme";
import {
  AnimatePresenceProvider,
  AuthProvider,
  GeolocationProvider,
  RouterProvider,
  StoreProvider,
  SentryProvider,
} from "@shared/providers";

import "react-swipeable-list/dist/styles.css";
import "@mantine/core/styles.css";
import "./styles/global.scss";
import "./styles/theme.scss";
import { Loader } from "@widgets/Loader";

export const App: FC = () => {
  const [isProvidersMounted, setIsProvidersMounted] = useState(false);

  useEffect(() => {
    setIsProvidersMounted(true);
  }, []);

  if (!isProvidersMounted) {
    return <Loader />;
  }

  return (
    <SentryProvider>
      <StoreProvider>
        <AuthProvider>
          <GeolocationProvider>
            <MantineProvider theme={theme} defaultColorScheme="dark">
              <AnimatePresenceProvider>
                <RouterProvider />
              </AnimatePresenceProvider>
            </MantineProvider>
          </GeolocationProvider>
        </AuthProvider>
      </StoreProvider>
    </SentryProvider>
  );
};
